import React, { useRef, useState } from "react";

import Input from "../../../controls/Input";
import {
  classNames,
  convertToDefEventPara,
  formatDate,
  formatDateWithoutParsing,
} from "../../../../shared/utility";
import InputWithSearch from "../../../controls/InputWithSearch";
import SelectMenu from "../../../controls/SelectMenu";
import { addDays, isValid } from "date-fns";

export default function NewPackageDetails2(props) {
  const {
    errors,
    handleInputChange,
    handleLocationChange,
    locationOptions,
    zoneOptions,
    values,
    showNumberPad,
    setShowNumberPad,
    fetchProductByPlu,
    setValues,
    scaleData,
    setScaleData,
    resolvePackagingLocationDefaults,
  } = props;

  const productPluRef = useRef();

  const [pluSearchInProgress, setPluSearchInProgress] = useState(false);

  const onFetchProductByPlu = async function (scannedPlu) {
    if (scannedPlu || scannedPlu !== "") {
      setPluSearchInProgress(true);

      const fetchResult = await fetchProductByPlu(scannedPlu);

      if (fetchResult.success) {
        const fetchedItem = fetchResult.data.product;

        const baseDate = (() => {
          const fromProduction = values.production_date
            ? new Date(values.production_date)
            : null;
          if (fromProduction && isValid(fromProduction)) return fromProduction;

          const fromPackaging = values.packaging_date
            ? new Date(values.packaging_date)
            : null;
          if (fromPackaging && isValid(fromPackaging)) return fromPackaging;

          return new Date();
        })();

        const shelfLifeDays = Number(fetchedItem.shelf_life) || 0;
        const newShelfLife = addDays(baseDate, shelfLifeDays);

        setValues((prev) => ({
          ...prev,
          product_id: fetchedItem.id,
          product_name: fetchedItem.name_en,
          description_en: fetchedItem.description_en,
          packing_size: fetchedItem.weight,
          shelf_life: fetchedItem.shelf_life,
          best_before_date: isValid(newShelfLife)
            ? formatDateWithoutParsing(newShelfLife)
            : values.best_before_date || "",
          ...resolvePackagingLocationDefaults({ product: fetchedItem }),
        }));
        setScaleData((prev) => ({ ...prev, packing_size: fetchedItem.weight }));
      } else {
        setValues((prev) => ({
          ...prev,
          product_id: null,
          product_name: "",
          description_en: "",
          packing_size: "",
          shelf_life: "",
          best_before_date: "",
          location: null,
          zone: null,
        }));
        setScaleData((prev) => ({ ...prev, packing_size: "" }));
      }
      setPluSearchInProgress(false);
    }
  };

  return (
    <div className="p-4 card-custom">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="col-span-2">
          <InputWithSearch
            name="plu"
            actionCall={() => onFetchProductByPlu(values.plu)}
            onChange={handleInputChange}
            placeholder="Product Plu"
            ref={productPluRef}
            type="search"
            value={values.plu}
            disableSearch={pluSearchInProgress}
            error={errors.plu}
          />
        </div>
        <div className="col-span-2">
          <Input
            label="Product name"
            name="product_name"
            onChange={handleInputChange}
            value={values.product_name}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
        </div>
        <div className="col-span-2">
          <Input
            label="Product description"
            name="description_en"
            onChange={handleInputChange}
            value={values.description_en}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
        </div>
        <div className="col-span-1">
          <SelectMenu
            handleInputChange={handleLocationChange}
            name="location"
            options={locationOptions}
            value={values.location}
            title="Location"
            placeholder="Select location…"
            error={errors.location}
          />
        </div>
        <div className="col-span-1">
          <SelectMenu
            handleInputChange={handleInputChange}
            name="zone"
            options={zoneOptions}
            value={values.zone}
            title="Zone"
            placeholder={
              values.location?.value
                ? "Select zone…"
                : "Select location first…"
            }
            disabled={!values.location?.value}
            error={errors.zone}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Production date"
            name="production_date"
            onChange={handleInputChange}
            value={formatDate(values.production_date)}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            //error={errors.production_room}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Best before date"
            name="best_before_date"
            onChange={handleInputChange}
            value={formatDate(values.best_before_date)}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            //error={errors.production_room}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Case weight"
            name="packing_size"
            onChange={handleInputChange}
            value={scaleData.packing_size}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            //error={errors.production_room}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Shelf life"
            name="shelf_life_date"
            onChange={handleInputChange}
            value={values.shelf_life}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            //error={errors.production_room}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Serial number"
            name="serial_number"
            onChange={handleInputChange}
            value={values.serial_number}
            labelOn={true}
            disabled={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            //error={errors.production_room}
          />
        </div>
        <div className="col-span-1">
          <Input
            label="Label to print"
            name="number_of_label_to_print"
            onChange={handleInputChange}
            onClick={() => {
              setShowNumberPad({
                show: true,
                name: "number_of_label_to_print",
                onChange: handleInputChange,
                value: values.number_of_label_to_print,
                showNumberPad: showNumberPad,
                setShowNumberPad: setShowNumberPad,
                disabledDot: true,
              });
            }}
            min={1}
            max={values.is_free_weight ? 1 : 999999}
            value={values.number_of_label_to_print}
            labelOn={true}
            type="number"
            pattern="[0-9]*"
            inputmode="numeric"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            error={errors.number_of_label_to_print}
          />
        </div>
        <div className="col-span-2">
          <Input
            label="Lot number"
            name="lot_number"
            onChange={handleInputChange}
            value={values.lot_number}
            labelOn={true}
            type="text"
            disabled={true}
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            //error={errors.lot_number}
          />
        </div>
      </div>
    </div>
  );
}
